module.exports = __webpack_public_path__ + "media/images/flags/1x1/maf-70b2d3dba703db85e533a11c36469a78.svg";